var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSsl = function SvgSsl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#SSL_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.143 47.606-9.471 4.038 11.265 2.602-1.794-6.64Z",
    fill: "url(#SSL_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.224 47.606 9.468 4.038-11.262 2.602 1.794-6.64Z",
    fill: "url(#SSL_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.154 63.819c-4.209-1.605-8.143-4.03-11.695-7.208-3.397-3.04-6.373-6.706-8.846-10.895-2.439-4.133-4.332-8.68-5.626-13.517a59.047 59.047 0 0 1-1.985-15.247c0-2.648.179-5.325.533-7.958l.898-6.681 6.433 2.015a24.378 24.378 0 0 0 7.294 1.113c4.235 0 8.459-1.127 12.213-3.258L32.18.59l2.806 1.593.125.068.013.007.178.096c3.677 2.018 7.79 3.086 11.896 3.086 2.484 0 4.939-.375 7.294-1.113l6.434-2.016.898 6.682c.354 2.634.532 5.311.532 7.958 0 5.144-.656 10.23-1.951 15.117-1.27 4.796-3.131 9.313-5.53 13.424-2.429 4.164-5.356 7.82-8.699 10.866-3.491 3.18-7.363 5.63-11.508 7.277l-.102.04a28 28 0 0 1-.36.142l-2.026.772-2.023-.772h-.002Z",
    fill: "url(#SSL_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.503 60.279c-3.774-1.439-7.313-3.623-10.518-6.491-3.108-2.78-5.836-6.145-8.11-9.997-2.265-3.836-4.024-8.066-5.229-12.57A55.236 55.236 0 0 1 5.79 16.952c0-2.48.168-4.987.5-7.453l.299-2.228 2.145.672a28.163 28.163 0 0 0 8.426 1.286c4.89 0 9.76-1.297 14.083-3.751l.935-.53.935.53c.07.04.14.077.21.115l.154.084c4.233 2.324 8.976 3.553 13.719 3.553 2.869 0 5.704-.433 8.426-1.286l2.145-.672.3 2.228c.33 2.466.499 4.974.499 7.453 0 4.816-.615 9.576-1.825 14.146-1.184 4.467-2.913 8.668-5.14 12.485-2.236 3.832-4.92 7.187-7.979 9.975-3.153 2.872-6.638 5.078-10.357 6.557l-.107.043a15.07 15.07 0 0 1-.306.12l-.675.258-.674-.258Z",
    fill: "url(#SSL_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.19 9.751a29.966 29.966 0 0 1-8.992 1.372c-5.096 0-10.113-1.306-14.63-3.785-.13-.072-.26-.14-.388-.213-4.617 2.62-9.776 3.998-15.018 3.998-3.07 0-6.084-.46-8.992-1.372a54.148 54.148 0 0 0-.482 7.202c0 19.108 10.028 36.041 24.493 41.556.13-.05.258-.102.387-.153 14.256-5.668 24.106-22.467 24.106-41.404 0-2.403-.161-4.815-.482-7.201h-.002Z",
    fill: "url(#SSL_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.557 20.445h-.122V18.23a6.087 6.087 0 0 0-6.08-6.08 6.087 6.087 0 0 0-6.08 6.08v2.216h-.402c-.79 0-1.432.64-1.432 1.432v9.161c0 .79.64 1.43 1.432 1.43h12.685c.79 0 1.431-.64 1.431-1.43v-9.161c0-.79-.64-1.432-1.431-1.432h-.001Zm-5.767 6.592v2.073a.575.575 0 1 1-1.15 0v-2.073a1.006 1.006 0 1 1 1.15 0Zm3.941-8.808v2.216h-8.753V18.23a4.382 4.382 0 0 1 4.377-4.377 4.382 4.382 0 0 1 4.377 4.377Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.691 51.644H5.67L2.055 35.39h60.25l-3.614 16.254Z",
    fill: "url(#SSL_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.928 45.577c0 .624-.16 1.184-.482 1.681-.32.497-.79.886-1.41 1.168-.619.28-1.353.422-2.2.422-1.018 0-1.857-.193-2.518-.576a3.352 3.352 0 0 1-1.142-1.108c-.293-.462-.44-.91-.44-1.347a.9.9 0 0 1 .264-.65c.176-.181.4-.271.671-.271.22 0 .407.07.56.21.151.141.282.35.39.627.13.328.273.602.425.822.152.22.366.402.643.545.277.143.64.214 1.09.214.62 0 1.122-.144 1.509-.432.387-.288.58-.648.58-1.079 0-.342-.105-.62-.313-.834a2.024 2.024 0 0 0-.808-.488c-.33-.113-.773-.232-1.325-.359-.741-.173-1.361-.376-1.86-.608a3.005 3.005 0 0 1-1.188-.949c-.293-.4-.44-.898-.44-1.495 0-.596.155-1.07.464-1.512.31-.44.757-.779 1.344-1.016.585-.237 1.275-.356 2.067-.356.632 0 1.18.079 1.642.236.461.157.844.366 1.15.626.304.26.526.533.667.819.141.286.21.565.21.837a.987.987 0 0 1-.263.671.84.84 0 0 1-.658.299c-.239 0-.42-.06-.544-.18-.125-.12-.26-.315-.405-.587-.187-.39-.412-.693-.675-.91-.263-.219-.685-.328-1.266-.328-.54 0-.974.119-1.305.356-.33.236-.495.521-.495.854 0 .206.056.385.168.534.113.15.268.279.464.387.197.108.396.193.598.254.202.06.534.15.998.267.581.136 1.108.286 1.579.45.471.164.872.363 1.203.598.33.234.588.53.773.89.185.358.278.797.278 1.318ZM36.533 45.577c0 .624-.16 1.184-.481 1.681-.322.497-.79.886-1.41 1.168-.62.282-1.353.422-2.2.422-1.018 0-1.857-.193-2.518-.576a3.352 3.352 0 0 1-1.143-1.108c-.293-.462-.44-.91-.44-1.347a.9.9 0 0 1 .264-.65c.176-.181.4-.271.672-.271.22 0 .407.07.559.21.152.141.282.35.39.627.131.328.273.602.425.822.152.22.367.402.644.545.276.143.64.214 1.09.214.619 0 1.122-.144 1.508-.432.387-.288.58-.648.58-1.079 0-.342-.104-.62-.312-.834a2.02 2.02 0 0 0-.81-.488c-.33-.113-.772-.232-1.325-.359-.74-.173-1.36-.376-1.86-.608a3.005 3.005 0 0 1-1.188-.949c-.293-.4-.44-.898-.44-1.495 0-.596.155-1.07.465-1.512.31-.44.757-.779 1.343-1.016s1.276-.356 2.068-.356c.633 0 1.18.079 1.642.236.462.157.845.366 1.15.626.304.26.527.533.668.819.14.286.21.565.21.837a.988.988 0 0 1-.263.671.84.84 0 0 1-.658.299c-.24 0-.421-.06-.545-.18-.124-.12-.259-.315-.404-.587-.188-.39-.413-.693-.676-.91-.262-.219-.684-.328-1.265-.328-.54 0-.974.119-1.305.356-.33.236-.496.521-.496.854 0 .206.056.385.169.534.112.15.267.279.464.387.197.108.396.193.598.254.201.06.534.15.998.267.58.136 1.107.286 1.578.45.471.164.872.363 1.203.598.33.234.588.53.773.89.186.358.278.797.278 1.318ZM40.354 39.452v7.504h4.233c.337 0 .596.082.776.246.18.164.271.37.271.619 0 .248-.09.458-.267.615-.178.157-.439.236-.781.236h-5.042c-.455 0-.782-.1-.981-.302-.2-.202-.3-.528-.3-.978v-7.94c0-.421.096-.738.286-.948a.96.96 0 0 1 .749-.317c.31 0 .568.105.763.313.194.209.292.526.292.953Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__b",
    x1: 11.305,
    y1: 50.698,
    x2: 11.305,
    y2: 53.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__c",
    x1: 53.061,
    y1: 51.007,
    x2: 53.061,
    y2: 54.089,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0080AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0054AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__d",
    x1: 17.155,
    y1: -6.57,
    x2: 53.212,
    y2: 54.316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7D63F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__e",
    x1: 32.12,
    y1: 3.626,
    x2: 32.374,
    y2: 62.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39B54A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9ED33F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7D63F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__f",
    x1: 32.179,
    y1: 7.125,
    x2: 32.179,
    y2: 58.509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285910"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09210C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SSL_svg__g",
    x1: 32.18,
    y1: 34.859,
    x2: 32.18,
    y2: 52.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SSL_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .59)",
    d: "M0 0h64v64H0z"
  })))));
};
export { SvgSsl as ReactComponent };
export default __webpack_public_path__ + "static/SSL.6e39c2aa.svg";